export enum FormType {
  INPUT = 'input',
  SELECT = 'select',
}
